module.exports = __webpack_public_path__ + "static/media/Investment.f3c4c09d.png";